import { CarRental, DirectionsCar, DirectionsWalk, Hail, Home, PedalBike } from "@mui/icons-material";
import { Divider, Stack, Typography } from "@mui/material";

import { GqlPlannerV2SummaryTravelMethod } from "~/__generated__";
import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatTime } from "~/modules/app/util/formatters";

import { ShiftItemTimeAndTravelFragment } from "./fragments.generated";

type Props = {
    shift: ShiftItemTimeAndTravelFragment;
};

export default function ShiftTimeAndTravel({ shift }: Props) {
    const summary = shift.summary;

    const startAt = parseStringToDate(shift.startTime);
    const endAt = parseStringToDate(shift.endTime);

    // Derive whether the shift's fieldworker is the driver, view-independently.
    const isDriver = shift.fieldworkerId === summary.plannerTravelGroupOwnerId;

    const TravelIcon = () => {
        switch (summary.travelMethod) {
            case GqlPlannerV2SummaryTravelMethod.Bike:
                return <PedalBike />;
            case GqlPlannerV2SummaryTravelMethod.PrivateCar:
                return isDriver ? <DirectionsCar /> : <Hail />;
            case GqlPlannerV2SummaryTravelMethod.MyWheels:
                return isDriver ? <CarRental /> : <Hail />;
            case GqlPlannerV2SummaryTravelMethod.Walk:
                return <DirectionsWalk />;
            default:
                return null;
        }
    };

    return (
        <Stack direction="row">
            <Stack direction="row" alignItems="center" spacing={1}>
                <Stack direction="row" alignItems="center" gap={0.5}>
                    <TravelIcon />
                    <Typography variant="body2">{formatTime(startAt)}</Typography>
                </Stack>
                <Divider sx={{ width: "100%", borderStyle: "dashed" }} />
                <Stack direction="row" alignItems="center" gap={0.5}>
                    <Home />
                    <Typography variant="body2">{formatTime(endAt)}</Typography>
                </Stack>
            </Stack>
        </Stack>
    );
}
